// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\CCardStatusUpdates\CoordinationCardStatusUpdateRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// CoordinationCardStatusUpdateRequestData is the class that CoordinationCardStatusUpdateRequest serializes to/from
export interface CoordinationCardStatusUpdateRequestData {
	
    StatusId : number;
	
    StatusReason : string | null;
}

// CoordinationCardStatusUpdateRequestOptions is the class which may be passed to the CoordinationCardStatusUpdateRequest constructor to define optional initial data values
export interface CoordinationCardStatusUpdateRequestOptions {
	
    StatusId? : number;
	
    StatusReason? : string | null;
}

export class CoordinationCardStatusUpdateRequest {
	
    public StatusId : DataSignal<number>;
	
    public StatusReason : DataSignal<string | null>;

    constructor();
    constructor(data : CoordinationCardStatusUpdateRequestOptions);
    constructor(data: CoordinationCardStatusUpdateRequestOptions | null = null) {
	    
        this.StatusId = jsonableObservable(S.value<number>(data && data.StatusId !== undefined ? data.StatusId : 0));
	    
        this.StatusReason = jsonableObservable(S.value<string | null>(data && data.StatusReason !== undefined ? data.StatusReason : null));
    }

    static key(obj : CoordinationCardStatusUpdateRequest) {
        return ;
    }
    
    static dataKey(obj : CoordinationCardStatusUpdateRequestOptions) {
        return ;
    }

    static update(obj : CoordinationCardStatusUpdateRequest, data : CoordinationCardStatusUpdateRequestOptions) {
        S.freeze(() => {
	        
            if (data.StatusId !== undefined) obj.StatusId(data.StatusId);
	        
            if (data.StatusReason !== undefined) obj.StatusReason(data.StatusReason);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationCardStatusUpdateRequest.ts